$(document).ready(function() {
    const $galleryContainer = $('#product-gallery-slider');
    if ($galleryContainer.length === 0) return;

    const $prevArrow = $('.prev-arrow');
    const $nextArrow = $('.next-arrow');

    let isSliderActive = false;
    let $track, $slides;
    let currentIndex = 0;
    
    let isDragging = false, startPos = 0, currentTranslate = 0, prevTranslate = 0, animationID;

    // MODIFICA CHIAVE: Aggiunto il parametro "forceRebuild"
    function initializeSlider(forceRebuild = false) {
        const shouldBeActive = window.innerWidth < 768;

        // NUOVA LOGICA: Gestisce l'attivazione/riattivazione
        if (shouldBeActive) {
            // Attiva lo slider se non è attivo OPPURE se siamo forzati a ricostruirlo
            if (!isSliderActive || forceRebuild) {
                console.log(forceRebuild ? "✅ Forzo la ricostruzione dello slider..." : "✅ Attivo lo slider custom...");
                
                // Pulisci eventuali strutture precedenti prima di ricostruire
                // Questo rende la funzione più sicura
                if ($galleryContainer.find('.gallery-track').length > 0) {
                     $galleryContainer.find('.gallery-slide').unwrap();
                }

                isSliderActive = true;

                $galleryContainer.removeClass('row').wrapInner('<div class="gallery-track"></div>');
                $track = $galleryContainer.find('.gallery-track');
                $slides = $track.children();
                $slides.removeClass('col-xs-12 col-md-6').addClass('gallery-slide');
                
                $track.css('touch-action', 'pan-y');

                bindEvents();
                goToSlide(0, false);
            }
        // NUOVA LOGICA: Gestisce la disattivazione
        } else {
            if (isSliderActive) {
                console.log("❌ Disattivo lo slider custom...");
                isSliderActive = false;
                
                unbindEvents();
                
                // Controlla che il track esista prima di provare a rimuoverlo
                if ($galleryContainer.find('.gallery-track').length > 0) {
                    $galleryContainer.find('.gallery-slide').unwrap();
                }
                
                $galleryContainer.addClass('row');
                $galleryContainer.children().addClass('col-xs-12 col-md-6').removeClass('gallery-slide').css('transform', '');
                
                $track = null;
                $slides = null;
            }
        }
    }
    
    function goToSlide(index, animate = true) {
        if (!isSliderActive || !$slides || $slides.length === 0) return;
        
        const totalSlides = $slides.length;
        currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
        
        const offset = -currentIndex * 100;

        if (animate) {
            $track.css('transition', 'transform 0.3s ease-in-out');
        } else {
            $track.css('transition', 'none');
        }

        $track.css('transform', `translateX(${offset}%)`);

        const galleryWidth = $galleryContainer.width();
        prevTranslate = -currentIndex * galleryWidth;
        currentTranslate = prevTranslate;

        $prevArrow.prop('disabled', currentIndex === 0);
        $nextArrow.prop('disabled', totalSlides <= 1 || currentIndex === totalSlides - 1);
    }

    function bindEvents() {
        $prevArrow.off('.customSlider').on('click.customSlider', () => goToSlide(currentIndex - 1));
        $nextArrow.off('.customSlider').on('click.customSlider', () => goToSlide(currentIndex + 1));
        
        $galleryContainer.off('.customSlider').on('mousedown.customSlider touchstart.customSlider', '.gallery-track', dragStart);
        $(window).off('mousemove.customSlider touchmove.customSlider').on('mousemove.customSlider touchmove.customSlider', drag);
        $(window).off('mouseup.customSlider touchend.customSlider').on('mouseup.customSlider touchend.customSlider', dragEnd);
    }

    function unbindEvents() {
        $prevArrow.off('.customSlider');
        $nextArrow.off('.customSlider');
        $galleryContainer.off('.customSlider');
        $(window).off('.customSlider');
    }
    
    function dragStart(e) {
        if (!isSliderActive) return;
        isDragging = true;
        startPos = getPositionX(e);
        $track.css('transition', 'none');
        animationID = requestAnimationFrame(animation);
    }
    
    function drag(e) {
        if (isDragging) {
            const currentPosition = getPositionX(e);
            currentTranslate = prevTranslate + currentPosition - startPos;
        }
    }

    function animation() {
        if (!isDragging) return;
        setTranslate();
        requestAnimationFrame(animation);
    }
    
    function setTranslate() {
        $track.css('transform', `translateX(${currentTranslate}px)`);
    }

    function dragEnd() {
        if (!isDragging || !$slides) return;
        
        cancelAnimationFrame(animationID);
        isDragging = false;
        
        const movedBy = currentTranslate - prevTranslate;
        
        if (movedBy < -50 && currentIndex < $slides.length - 1) {
            currentIndex++;
        }
        if (movedBy > 50 && currentIndex > 0) {
            currentIndex--;
        }
        
        goToSlide(currentIndex, true);
    }
    
    function getPositionX(e) {
        return e.type.includes('touch') ? e.originalEvent.touches[0].clientX : e.pageX;
    }

    const observer = new MutationObserver(function(mutations) {
        console.log("🕵️‍♂️ Rilevata modifica HTML nella gallery! Re-inizializzo...");
        
        observer.disconnect();
        
        // MODIFICA CHIAVE: Passiamo "true" per forzare la ricostruzione
        initializeSlider(true);
        
        observer.observe($galleryContainer[0], { childList: true });
    });

    observer.observe($galleryContainer[0], { childList: true });
    
    // Il resize non forza la ricostruzione, si comporta normalmente
    $(window).on('resize', () => initializeSlider(false));
    
    initializeSlider();
});